import { Typography } from 'antd'
import React from 'react';
import Legend from '../../../../components/Legend/Legend';
import { Trans, useTranslation } from 'react-i18next';

export default function HelpTab() {
    const { t } = useTranslation("observations");

    return <>
        <Typography.Title level={4}>{t("ohjetabiOtsikko")}</Typography.Title>
        <p>
            <span>
                {t("ohjetabiEkaRivi")}
            </span>
        </p>
        <p>
            <span>
                {t("ohjetabiTokaRivi")}
            </span>
        </p >
        <p>
            <span>
                {t("ohjetabiKolmasRivi")}
            </span>
        </p >
        <p>
            <span>
                <Trans i18nKey="observations:ohjetabiNeljasRivi" components={{
                    i: <i className="esri-icon-layers" style={{ "fontWeight": "bold" }} />
                }}>
                    Karttatasoja voi valita näkyviin oikean alanurkan <i className="esri-icon-layers" style={{ "fontWeight": "bold" }} />-napin takaa. Sieltä voi myös säätää
                    jokaisen karttatason läpinäkyvyyttä erikseen.
                </Trans>
            </span>
        </p>
        <p>
            {t("ohjetabiViidesRivi")}
        </p>
        <p>
            <span>{t("ohjetabiKuudesRivi")}</span>
        </p>
        <p>
            <Trans i18nKey="observations:ohjetabiSeitsemäsRivi" components={{
                i: <i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} />
            }}>
                Kartan voi tarkentaa omaan sijaintiin painamalla oikean alanurkan <i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} />-nappulaa.
            </Trans>
        </p >
        <p>
            <span>{t("ohjetabiKahdeksasRivi")}</span>
        </p>

        <Legend />
    </>
}